import { reactive } from 'vue'

const key = 'gl-panel-menu-collapsed'
let collapsed = false
try { collapsed = localStorage.getItem(key) === '1' } catch (_) {}
export const panelLayout = reactive({ collapsed })
export function togglePanelMenu () {
  panelLayout.collapsed = !panelLayout.collapsed
  try { localStorage.setItem(key, panelLayout.collapsed ? '1' : '0') } catch (_) {}
}
